if (!customElements.get('featured-collections-slider')) {
  class FreturedColletionsSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};

      this.initSlider(swiperOptions);
    }

    initSlider(swiperOptions) {
      this.slider = new Swiper(this, {
        slidesPerView: swiperOptions.slidePerViewMobile,
        navigation: {
          nextEl: '.featured-collections__swiper-button--next',
          prevEl: '.featured-collections__swiper-button--prev',
        },

        spaceBetween: swiperOptions.spaceBetweenMobile || 2,
        breakpoints: {
          750: {
            enabled: true,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 2,
            slidesPerView: swiperOptions.slidePerViewDesktop,
            loop: false,
            navigation: {
              nextEl: '.featured-collections__swiper-button--next',
              prevEl: '.featured-collections__swiper-button--prev',
            }
          }
        }
      });
    }
  }

  customElements.define('featured-collections-slider', FreturedColletionsSlider);
}